import gql from 'graphql-tag';

export const getShiftTurnoverHistories = gql`
  query getShiftTurnoverHistories($id: String) {
    getShiftTurnoverHistories(id: $id) {
      updater
      updatedAt
    }
  }
`;
